import { Modal } from "@next-platform/client-common-spicy-ui";
import type { Dispatch, JSX, SetStateAction } from "react";

import { Row, SpicyButton, Text } from "@/components/customComponents";

const CLOSE_BUTTON_TEXT = "Close";

type ErrorModalProps = {
  errorModalVisible: boolean;
  setErrorModalVisible: Dispatch<SetStateAction<boolean>>;
  errorModalMessage: string;
};

function ErrorModal({ errorModalVisible, setErrorModalVisible, errorModalMessage }: ErrorModalProps): JSX.Element {
  const handleOnClose = (isOpen: boolean) => {
    if (isOpen) {
      return;
    }

    setErrorModalVisible(false);
  };

  return (
    <Modal title="Error" classNames={{ title: "text-center pl-[28px]" }} backdrop="blur" open={errorModalVisible} onOpenChange={handleOnClose}>
      <div className="text-center">
        <Text b>{errorModalMessage}</Text>
      </div>
      <Row className="justify-center">
        <SpicyButton variant="primary" color="primary_strong" onPress={() => setErrorModalVisible(false)}>
          {CLOSE_BUTTON_TEXT}
        </SpicyButton>
      </Row>
    </Modal>
  );
}

export default ErrorModal;
